import {IntermediatePart} from "../../intermediatePart";
import { Vanity } from "../../parts/vanity";
import {createParentPositions, METADATA, SIDE_POSITIONS, VANITY_TYPES, LOOK_ROOM_TYPES} from "../../constants";
import {getDbFeatureProperty, getSkuWithoutDot, removeLookPointFor} from "../../../lookNavigation/lookFunctions2";
import {navFeatureCLick} from "../../../lookNavigation/lookFunctions";
import {getCurrentRoomType} from "../../../../appLayout";
import {findNextVanityTypeFeature} from "../../../lookNavigation/lookNavigationFunctions";
import {IS_QKB_UI} from "../../../../../config";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Sink extends IntermediatePart {
  constructor(isChild, partNumber = 0) {
    super(isChild);
    this.partNumber = partNumber;
    this.partId = 'vanity_sink';
    this.partName = 'Sink';
    this.translateId = "visualizer.bathroom.vanity.vanity_sink";
    this.homePageTitle = 'Sinks';
    this.visible = [Vanity.Types.Custom];
    // this.canBeDisabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  load(dbFeature) {
    if (!dbFeature.metaData["MountType"]) {
      dbFeature.metaData["MountType"] = [METADATA.Inner]
    }
    if (!dbFeature.metaData["MatchingFeature"] || dbFeature.metaData["MountLevel"]) {
      // added MountLevel for new sinks that can be applied for vanities with countertops
      dbFeature.metaData["MatchingFeature"] = [METADATA.NO];
      dbFeature.metaData["CustomVanityType"] = VANITY_TYPES.vanity_cabinet;
    }
    if (dbFeature.metaData["MountHoles"] && dbFeature.metaData["MountHoles"].includes("0")) {
      dbFeature.metaData["MountHoles"] = ["0", "1", "4", "8"]; // UnderMount Sinks - they can be used with all faucet types
    }
    // if (!dbFeature.metaData["SingleHole"]) {
    //   dbFeature.metaData["SingleHole"] = dbFeature[getDbFeatureProperty("lixilProductSubCategory")] === METADATA.WallHungSinks  // todo change to filters
    //     ? [METADATA.WallHungSinks]
    //     : [METADATA.ALL];
    // }
    if (Array.isArray(dbFeature.metaData["SinkWidth"]) && dbFeature.metaData["SinkWidth"][0]) {
      dbFeature.metaData["SinkWidth"] = +dbFeature.metaData["SinkWidth"][0] + 5; // convert to number
      // for example, width is 23, 23 + 5 = 28, vanities with VanitySize 24 will be hidden
    } else if (Array.isArray(dbFeature.metaData["Countertop"]) && Array.isArray(dbFeature.metaData["VanitySize"])) {
      dbFeature.metaData["VanityWidth"] = +dbFeature.metaData["VanitySize"][0]; // convert to number
      // if (dbFeature.metaData["VanityWidth"] === 60) {
      //   dbFeature.metaData["VanityWidth"] = 64
      // } else if (dbFeature.metaData["VanityWidth"] === 24) {
      //   dbFeature.metaData["VanityWidth"] = 30
      // }
    }
    if (Array.isArray(dbFeature.metaData["WaterLevel"]) && dbFeature.metaData["WaterLevel"][0]) {
      dbFeature.metaData["WaterLevel"] = +dbFeature.metaData["WaterLevel"][0] + 3; // convert to number and add 3! they should be higher + 3
    }
    if (!dbFeature.metaData["SinkCount"]) {
      dbFeature.metaData["SinkCount"] = ["S"];
    }
    dbFeature.metaData["layerPosition"] = !dbFeature.metaData["Side"]
      ? SIDE_POSITIONS[0]
      : dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    const partNumber = dbFeature.metaData["layerPosition"] === SIDE_POSITIONS[0] ? 1 : 2;
    return super.load_(dbFeature, new Sink(false, partNumber), true, partNumber === 1 ? 'features' : 'featuresParts');
  }

  // eslint-disable-next-line no-unused-vars
  navigationSubItems(filters, searchText, forFeature, filterGroups, restOptions = {}) {
    const {firstOpenedConditions, returnAllFeatures} = restOptions;
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as && !IS_QKB_UI) {
      const featuresList = this.getFeaturesForNavigationFrom(returnAllFeatures);
      const filteredAvailableFeatures = this.getFeaturesBySearchText(this.getFilteredFeaturesByFilters(filters, featuresList), searchText);
      let featuresToDisplay = this.navigationSubItemsWithFilterMultipleConditions(firstOpenedConditions || this.getArrayOfConditions(true), filteredAvailableFeatures);
      filteredAvailableFeatures.forEach(feature => {
        if (!feature.metaData["CustomVanityType"] || !feature.metaData["CustomVanityType"].length
          && featuresToDisplay.every(shownFeature => shownFeature.dbFeature.id !== feature.dbFeature.id)) {
          featuresToDisplay.push(feature);
        }
      });
      let sinkFeatures = [];
      if (this.activeFeature && this.activeFeature.metaData.layerPosition && Array.isArray(this.activeFeature.metaData.MountType)) {
        for (let sinkFeature of featuresToDisplay) {
          const alreadyExistingIndex = sinkFeatures.findIndex(feature => {
            return feature.dbFeature.sharedFeatureName === sinkFeature.dbFeature.sharedFeatureName
          });
          if (alreadyExistingIndex > -1) {
            if (sinkFeature.metaData.layerPosition && (this.activeFeature.metaData.layerPosition === sinkFeature.metaData.layerPosition)
              && sinkFeature.metaData.MountType && (this.activeFeature.metaData.MountType[0] === sinkFeature.metaData.MountType[0])) {
              sinkFeatures.splice(alreadyExistingIndex, 1, sinkFeature)
            }
          } else {
            sinkFeatures.push(sinkFeature);
          }
        }
      } else {
        sinkFeatures = featuresToDisplay;
      }
      return this.navigationItemsWithOptions(filters, forFeature, filterGroups, sinkFeatures, restOptions)
    }
    return super.navigationSubItems(filters, searchText, forFeature, filterGroups, restOptions)
  }

  getNextVanityTypeFeature() {
    const vanityParent = this.getParent().getParent();
    const currentActiveMatchingFeatureSku = vanityParent.getActiveSkuFromRelatedItem(vanityParent.vanity_type);
    const currentActiveMatchingFeatureMeta = vanityParent.getActiveMatchingMetaFromRelatedItem(vanityParent.vanity_type);
    const sinkSku = getSkuWithoutDot(this.dbFeature.sharedFeatureName);

    const currentMatchingMatchingFeature = this.metaData["MatchingFeature"] && (!currentActiveMatchingFeatureSku || !this.metaData["MatchingFeature"].includes(currentActiveMatchingFeatureSku));
    const currentMatchingMatchingSku = currentActiveMatchingFeatureMeta && !currentActiveMatchingFeatureMeta.includes(sinkSku);
    if (currentMatchingMatchingFeature || currentMatchingMatchingSku) {
      const relatedItem = vanityParent.relatedItems.find(relItem => relItem.partId === vanityParent.vanity_type);
      if (relatedItem) {
        return findNextVanityTypeFeature(this, relatedItem)
      }
    }
    return null
  }

  handleClick(forceClick = false, setVanityOnly = false) {
    const asBathroom = getCurrentRoomType() === LOOK_ROOM_TYPES.as;
    const featureIsLocked = getFeatureIsLocked(this, forceClick);
    if (asBathroom && !featureIsLocked) {
      const vanityParent = this.getParent().getParent();
      if (!this.metaData["CustomVanityType"] || !this.metaData["CustomVanityType"].length) {
        vanityParent.vanity_type = null;
      // } else if (!vanityParent.vanity_type || !this.metaData["CustomVanityType"].includes(vanityParent.vanity_type)) {
      } else if (!this.metaData["CustomVanityType"].includes(vanityParent.vanity_type)) {
        vanityParent.vanity_type = this.metaData["CustomVanityType"][0];
      }
      if (setVanityOnly) {
        return // vanity should be set after the sink updates it's layer positions
      }
      const matchFeature = this.getNextVanityTypeFeature();
      console.log("matchFeature", matchFeature);
      // console.log("forceClick", forceClick);
      if (matchFeature) {
        navFeatureCLick(matchFeature, false, forceClick, false)
      }
      // if (vanityParent.sink_type && vanityParent.sink_type.includes(SINK_TYPES.standAlone)) {
      //   // vanityParent.vanityCabinet.disabled = true;
      //   if (vanityParent.vanityCabinet.layerPositions) {
      //     Object.keys(vanityParent.vanityCabinet.layerPositions).forEach(position => {
      //       vanityParent.vanityCabinet.layerPositions[position] = null;
      //     })
      //   }
      // } else {
      //   // vanityParent.vanityCabinet.disabled = false;
      //   if (vanityParent.vanityCabinet.layerPositions) {
      //     Object.keys(vanityParent.vanityCabinet.layerPositions).forEach(position => {
      //       vanityParent.vanityCabinet.layerPositions[position] = vanityParent.vanityCabinet.getMatchingPositionFeature(position, vanityParent.vanityCabinet.activeFeature);
      //     })
      //   }
      // }
    }
    super.handleClick(forceClick);
    if (asBathroom && !featureIsLocked) {
      const vanityParent = this.getParent().getParent();
      vanityParent.updateVanityParts();
    }
  }

  isSinkWithCountertopIncluded() {
    return this.metaData["Countertop"] // ["disabled"]
  }

  handleChangeParent(nonCompatibleWith) {
    if (nonCompatibleWith === "faucet") {
      // some additional logic if needed
    } else {
      this.getParent().getParent().vanityCabinet.setActiveFeatureByFilter("Size", this.metaData["VanitySize"] ? this.metaData["VanitySize"][0] : null); // "60in", etc.
    }
  }

  setActiveFeatureByFilter(filterName, filterValue) {
    const featuresToDisplay = super.navigationSubItemsWithFilterMultipleConditions(this.getArrayOfConditions());
    const filteredFeatures = featuresToDisplay.filter((feature) => {
      return feature.metaData[filterName] && feature.metaData[filterName].includes(filterValue);
    });
    if (!super.tryToSetTheSameFeature(filteredFeatures)) {
      this.activeFeature = filteredFeatures.find(feature => !feature.dbFeature.displayName.includes("laceholder")) || filteredFeatures[0];
      const placeholderAvailableFeatures = filteredFeatures.filter(feature => {
        return feature.dbFeature.displayName.includes("laceholder")
      });
      this.placeholderFeature = placeholderAvailableFeatures[0];
    }
  }

  getCurrentFaucetMetaData() {
    const faucetParent = this.getParent().faucet;
    let metaObject = {};
    if (faucetParent && faucetParent.activeFeature) {
      const singleHoleMeta = faucetParent.activeFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] === METADATA.SingleHole
      || faucetParent.activeFeature.dbFeature[getDbFeatureProperty("lixilProductSubCategory")] === METADATA.WidespreadFaucets // todo change to filters
        ? METADATA.WallHungSinks
        : METADATA.ALL
      if (singleHoleMeta) {
        metaObject["SingleHole"] = singleHoleMeta
      }
    }
    return metaObject
  }

  // getArrayOfConditions(forNavigation = false) {
  getArrayOfConditions(forNavigation = false) {
    const conditions = super.getArrayOfConditions();
    // const currentFaucetMetaData = this.getCurrentFaucetMetaData();
    // if (currentFaucetMetaData["SingleHole"]) {
    //   conditions.push({
    //     propName: 'SingleHole',
    //     propValue: currentFaucetMetaData["SingleHole"]
    //   })
    // }
    const vanityParent = this.getParent();
    if (getCurrentRoomType(vanityParent.layout) === LOOK_ROOM_TYPES.as) {
      if (vanityParent.vanity_type && !forNavigation) {
        conditions.push({
          propName: "CustomVanityType",
          propValue: vanityParent.vanity_type
        });
        const activeMatchingVanity = vanityParent.getActiveSkuFromRelatedItem(vanityParent.vanity_type);
        const activeMatchingFeatures = vanityParent.getActiveMatchingMetaFromRelatedItem(vanityParent.vanity_type);
        const activeSideMeta = vanityParent.getActiveMatchingMetaFromRelatedItem(vanityParent.vanity_type, "Side");
        if (activeMatchingVanity) {
          conditions.push({
            propName: "MatchingFeature",
            propValue: activeMatchingFeatures.includes(METADATA.NO) ? METADATA.NO : activeMatchingVanity
          });
        }
        if (activeMatchingFeatures) {
          conditions.push({
            propName: "FeatureSku",
            propValue: activeMatchingFeatures
          });
        }
        if (activeSideMeta && activeSideMeta.includes("C") && !vanityParent.isDoubleVanity()) {
          conditions.push({
            propName: "Side",
            propValue: activeSideMeta
          });
        }
        if (this.activeFeature?.isSinkWithCountertopIncluded() && vanityParent.vanity_type === VANITY_TYPES.vanity_cabinet) {
          const vanityCabinet = vanityParent.relatedItems.find(relItem => relItem.partId === vanityParent.vanity_type);
          if (vanityCabinet?.activeFeature) {
            conditions.push({
              propName: "SinkCount",
              propValue: vanityCabinet?.activeFeature?.metaData?.["SinkCount"]?.[0] || "S"
            });
          }
          if (vanityCabinet?.activeFeature && (typeof vanityCabinet?.activeFeature?.metaData?.["VanityWidth"] === "number")) {
            conditions.push({
              propName: "VanityWidth",
              propValue: vanityCabinet.activeFeature.metaData["VanityWidth"]
            });
          }
        }
      }
    }
    return conditions;
  }

  matchesMetaForCondition(...props) {
    const [name, value] = props;
    if (name === "SinkWidth") {
      // if no metadata - return true! back compatability
      return !this.metaData["SinkWidth"] || (this.metaData["SinkWidth"] < value)// current sink should be smaller than Vanity
    }
    if (name === "MountLevel"
      && (!Array.isArray(this.metaData["MountType"]) || !this.metaData["MountType"].includes("V"))) {
      // sinks without the MountType V should ignore MountLevel metaData, they should be checked my MountType only
      return true
    }
    return super.matchesMetaForCondition(...props);
  }

  getActiveFeatureConditions(fromFeature = this.activeFeature) {
    let arrayOfConditions = super.getArrayOfConditions();
    ['MountType', 'MountHoles'].forEach((propName) => {
      if (fromFeature.metaData[propName]) {
        arrayOfConditions.push({
          propName,
          propValue: fromFeature.metaData[propName]
        })
      }
    })
    return arrayOfConditions
  }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      const vanityParent = this.getParent();
      return !vanityParent.vanity_type // pedestal sink only
    }
    return removeLookPointFor(parentObject, 3, "2", SIDE_POSITIONS[1])
      && removeLookPointFor(parentObject, 1, "1", SIDE_POSITIONS[1])
  }

}
